import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import NumberFormat from "react-number-format"; // https://github.com/s-yadav/react-number-format
import Icon from "../elements/icon";

const getMask = ({ type, allowDecimal }) => {
  switch (type) {
    case "currency":
      return {
        mask: {
          thousandSeparator: true,
          decimalScale: allowDecimal ? 2 : 0,
        },
        icon: <Icon icon="dollar" />,
        iconAlignment: "align-left",
      };
    case "percent":
      return {
        mask: {
          thousandSeparator: true,
          decimalScale: allowDecimal ? 2 : 0,
        },
        icon: <Icon icon="percent" />,
        iconAlignment: "align-right",
      };
    case "year":
      return {
        mask: {
          thousandSeparator: false,
          decimalScale: 0,
        },
      };
    default:
      return {
        mask: {
          thousandSeparator: true,
          decimalScale: allowDecimal ? 2 : 0,
        },
      };
  }
};

const NumericInput = ({
  onChange,
  value,
  maskType,
  allowDecimal,
  allowZero = true,
  integerLimit,
  valueLimit,
  showIcon,
  iconBackgroundColor,
  className,
  disabled,
  ...rest
}) => {
  const { mask, icon, iconAlignment } = getMask({ type: maskType, allowDecimal });
  const iconColor = value ? { backgroundColor: iconBackgroundColor } : {};
  const withPreventZero = (val) => val !== 0;
  const withValueLimit = (val) => !val || val <= valueLimit;
  const withIntegerLimit = (val) => Math.trunc(val).toString().length <= integerLimit;
  const iconLeft = showIcon && iconAlignment === "align-left";
  const iconRight = showIcon && iconAlignment === "align-right";
  const inputAlignClass = showIcon ? `et--numeric-input--${iconAlignment}` : "";
  const iconClassNames = classNames("et--numeric-input--icon", value ? "et--numeric-input--active" : "");

  const isValidValue = (value) => {
    const checkValueLimit = valueLimit ? withValueLimit(value) : true;
    const checkIntegerLimit = integerLimit ? withIntegerLimit(value) : true;
    const checkAllowZero = !allowZero ? withPreventZero(value) : true;
    const isValid = checkValueLimit && checkIntegerLimit && checkAllowZero;

    return isValid;
  };

  return (
    <div className={classNames("et--numeric-input", inputAlignClass)}>
      {iconLeft && (
        <span style={iconColor} className={iconClassNames}>
          {icon}
        </span>
      )}

      <NumberFormat
        value={value}
        disabled={disabled}
        className={className}
        onValueChange={({ floatValue }) => onChange(floatValue === undefined ? null : floatValue)}
        allowNegative={false}
        isAllowed={({ floatValue }) => isValidValue(floatValue)}
        {...mask}
        {...rest}
      />

      {iconRight && (
        <span style={iconColor} className={iconClassNames}>
          {icon}
        </span>
      )}
    </div>
  );
};

NumericInput.propTypes = {
  onChange: PropTypes.func,
  maskType: PropTypes.oneOf(["currency", "percent", "number", "year"]),
  allowZero: PropTypes.bool,
  allowDecimal: PropTypes.bool,
  showIcon: PropTypes.bool,
  integerLimit: PropTypes.number,
  valueLimit: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  iconBackgroundColor: PropTypes.string,
};

export default NumericInput;
